/**
 * @desc: 供应商注册
 * @created: 2020/4/27
 * @author: Colorfule
 * @version: v1.0
 */

import * as Models from '@/api/T3/supplierRegistration'

export default {
  namespaced: true,
  state: {
    checkoutListData: []
  },
  getters: {
    checkoutListData: state => state.checkoutListData
  },
  actions: {
    // 获取资料注册列表数据
    async getListData(ctx, payload) {
      const res = await Models.getListData(payload)
      return (res && res.status === 200 && res.data)
    },

    // 批量注册
    async postBatchRegister(ctx, payload) {
      const res = await Models.postBatchRegister(payload)
      return (res && res.status === 200 && res)
    },

    // 释放 
    async releaseSup(ctx, payload) {
      const res = await Models.releaseSup(payload)
      return (res && res.status === 200 && res)
    },

  },
  mutations: {

    setCheckoutListData: (state, data) => {
      state.checkoutListData = data;
    }
  }
}
